import EventBus from "../../../../util/EventBus";
import withNavigate from "../../../../util/useNavigate";
import Applet from "../../Applet";
import EnlilDetailDialog from "../../../../components/EnlilDetailDialog";

class DeveloperCredentialAuthorizationFormApplet extends Applet {
    state = {
        Name: "DeveloperCredentialAuthorizationFormApplet",
        Actions: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ReadPermission",
                            },
                            {
                                id: "CreatePermission",
                            },
                            {
                                id: "UpdatePermission",
                            },
                        ],
                    },
                ],
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ReadPermission",
                            },
                            {
                                id: "CreatePermission",
                            },
                            {
                                id: "UpdatePermission",
                            }
                        ],
                    },
                ],
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ReadPermission",
                            },
                            {
                                id: "CreatePermission",
                            },
                            {
                                id: "UpdatePermission",
                            },
                        ],
                    },
                ],
            },
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            ReadPermission: {
                id: "ReadPermission",
                enterpriseComponentAttribute: "ReadPermission",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Read Permission",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "Checkbox",
                requiresConfirmation: false,
            },
            CreatePermission: {
                id: "CreatePermission",
                enterpriseComponentAttribute: "CreatePermission",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Create Permission",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "Checkbox",
                requiresConfirmation: false,
            },
            UpdatePermission: {
                id: "UpdatePermission",
                enterpriseComponentAttribute: "UpdatePermission",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Update Permission",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "Checkbox",
                requiresConfirmation: false,
            },
        },
    };

    cancel() {
        super.cancel();

        EventBus.components.emit("developer-credential-authorization-form-applet-cancel");
    };

    setAction(action) {
        super.setAction(action);

        if (action === "Save Completed") {
            EventBus.components.emit("developer-credential-authorization-form-applet-save");
        }
    };

    render() {
        return <EnlilDetailDialog applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Authorization"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default withNavigate(DeveloperCredentialAuthorizationFormApplet);
